<template>
  <div class="mode-switcher">
    <div class="buttons">
      <a @click="cut" class="user-action-button cut" :class="{ active: mode === 'cut' }">
        <cut-icon class="icon" />
      </a>

      <a @click="seed" class="user-action-button seed" :class="{ active: mode === 'seed' }">
        <seed-icon class="icon" />
      </a>

      <a
        @click="openShopWindow"
        class="user-action-button shop"
        :class="{ active: mode === 'shop' }"
      >
        <buy-icon class="icon" />
      </a>
    </div>

    <div class="mode-description" v-if="mode === 'seed' || mode === 'cut'">
      <div v-if="mode === 'cut'">
        <div class="mode-name">伐採</div>
        <div class="mode-instruction">伐採したい木をタップしてください</div>
      </div>

      <div v-if="mode === 'seed'">
        <div class="mode-name">
          種まき
          <span class="selected-seed-name" v-if="selectedSeedType !== null">
            {{selectedSeedName}} ({{selectedSeedsCount}}コ)
            <a
              class="clear-selected-seed"
              @click="clearSelectedSeedType"
            >変更</a>
          </span>
        </div>
        <div class="mode-instruction">
          <div v-if="seeds.length === 0">先に種を購入する必要があります</div>
          <div v-else-if="selectedSeedType === null">種を選択してください</div>
          <div v-else-if="selectedSeedType !== null">種をまきたいマスをタップしてください</div>

          <div class="seed-list" v-if="seeds.length && selectedSeedType === null">
            <a
              v-for="seed in seeds"
              :key="`seeds-${seed.template.type}`"
              v-on:click="selectSeed(seed.template)"
              :class="{selected: selectedSeedType === seed.template.type}"
            >{{ seed.template.name }} ({{ seed.amount }}コ)</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeedIcon from '@/assets/seed-action.svg';
import CutIcon from '@/assets/cut-action.svg';
import BuyIcon from '@/assets/buy-action.svg';

export default {
  name: 'ModeSwitcher',
  components: {
    'seed-icon': SeedIcon,
    'cut-icon': CutIcon,
    'buy-icon': BuyIcon,
  },
  data() {
    return {
      seedCounts: {},
    };
  },
  mounted() {
    this.$store.dispatch('setObservers', {
      actions: {
        introStep1: () => {
          this.$store.dispatch('showIntro', {
            introjs: this.$intro,
            selector: '.user-action-button.cut',
            message:
              'このボタンをタップすると伐採モードに切り替えることができます。樹木を伐採することでゴールドを獲得できます。',
          });
        },
        introStep2: () => {
          this.$store.dispatch('showIntro', {
            introjs: this.$intro,
            selector: '.user-action-button.shop',
            message: 'ゴールドが溜まったらここで種を購入してみましょう。',
          });
        },
        introStep3: () => {
          this.$store.dispatch('showIntro', {
            introjs: this.$intro,
            selector: '.user-action-button.seed',
            message: '種を購入したらこのボタンで種を蒔くことができます。',
          });
        },
      },
    });
  },
  computed: {
    seeds() {
      return this.$store.state.game.assetManager.units;
    },
    mode() {
      return this.$store.state.userActionMode;
    },
    selectedSeedType() {
      return this.$store.state.selectedSeed
        ? this.$store.state.selectedSeed.type
        : null;
    },
    selectedSeedName() {
      return this.$store.state.selectedSeed
        ? this.$store.state.selectedSeed.name
        : null;
    },
    selectedSeedsCount() {
      return this.$store.state.selectedSeedsCount;
    },
  },
  methods: {
    selectSeed(unitTemplate) {
      this.$store.dispatch('selectSeed', unitTemplate);
    },
    clearSelectedSeedType() {
      this.$store.dispatch('selectSeed', null);
    },
    seed() {
      this.changeMode('seed');
    },
    cut() {
      this.changeMode('cut');
    },
    openShopWindow() {
      this.changeMode('shop');
    },
    changeMode(mode) {
      if (this.$store.state.game.stop) {
        alert('停止中は操作できません。');
        return;
      }

      this.$store.dispatch('setUserActionMode', { mode: mode, toggle: true });
    },
  },
};
</script>

<style lang="scss" scoped>
$buttonSize: 1.5rem;

.mode-switcher {
  position: relative;

  .user-action-button {
    display: block;
    width: $buttonSize;
    height: $buttonSize;
    line-height: $buttonSize;
    position: relative;
    float: left;
    margin-right: 1rem;

    .icon {
      width: 60%;
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &.active {
      transform: scale(1.2);
      background: rgba(#fff, 0.8);

      .label {
        display: block;
      }
    }
  }

  .mode-description {
    position: absolute;
    bottom: 1rem;
    text-align: left;
    background: #fff;
    padding: 0.5em 1em;
    border-radius: 3px;
    box-shadow: 0 2px 10px 0 rgba(#000, 0.1);
    font-size: 0.9rem;

    .mode-name {
      font-weight: bolder;
      margin-bottom: 0.5em;

      &:after {
        content: '';
        clear: both;
        display: block;
      }
    }
  }
}

.seed-list {
  margin-top: 0.5em;

  a {
    display: block;
    color: #333;
    padding: 0;
    line-height: 2.5rem;
    transition: background 0.5s;
    cursor: pointer;
    text-align: left;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-weight: bolder;
  }
}

.selected-seed-name {
  font-size: 0.9rem;
  font-weight: normal;
  float: right;

  .clear-selected-seed {
    display: inline-block;
    background: #0a5;
    color: #fff;
    font-size: 0.8rem;
    padding: 0.2em 1em;
    margin: 0 0 0 0.5em;
    border-radius: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/UserAction/ModeSwitcher.vue